import React, { ComponentPropsWithRef, FC } from 'react';
import { BreadCrumb } from '@components/BreadCrumb/BreadCrumb.component';
import { BreadCrumbStep } from '@components/BreadCrumb/BreadCrumb.types';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import classnames from 'classnames';

type Props = ComponentPropsWithRef<'header'> & {
  breadcrumbSteps?: BreadCrumbStep[];
  titleClassName?: string;
};

const PlcPageDetailInnovationHeader: FC<Props> = ({ breadcrumbSteps, className, children, ...rest }) => {
  const isMobile = useIsBreakpointDown(Breakpoint.m);
  const rootClass = classnames((isMobile || !breadcrumbSteps) && 'plc-pt-basis', className);

  return (
    <header className={rootClass} {...rest}>
      {breadcrumbSteps && <BreadCrumb className="plc-mb-s" customSpacing={true} steps={breadcrumbSteps || []} />}
      {children}
    </header>
  );
};

export { PlcPageDetailInnovationHeader };
